import { BarChart2, Users, Database } from 'lucide-react';
import { NavLink } from 'react-router-dom';

const navItems = [
  { id: 'tracker', label: 'Tracker', icon: BarChart2, to: '/tracker' },
  { id: 'children', label: 'Kinder', icon: Users, to: '/children' },
  { id: 'data', label: 'Daten', icon: Database, to: '/data' },
];

export default function BottomNav({ currentView, onViewChange }) {
  return (
    <nav className="bottom-nav">
      {navItems.map(item => (
        <NavLink
          key={item.id}
          to={item.to}
          className={({ isActive }) =>
            `bottom-nav__item ${isActive ? 'active' : ''}`
          }
          aria-label={item.label}
          onClick={() => onViewChange && onViewChange(item.id)}
        >
          <item.icon className="bottom-nav__icon" />
          <span className="bottom-nav__label">{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
} 